import { Package } from "src/app/shared/types/contract-types";
import { TranslateService } from "@ngx-translate/core";
import { PopupType } from "src/app/shared/enums/popup-types";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { Component, Input } from "@angular/core";
import { PackageService } from "src/app/shared/services/package.service";
import { TierManagmentService } from "src/app/shared/services/tier-managment.service";
import { Observable, take } from "rxjs";
import { UserRoles } from "src/app/shared/enums/user-roles";

@Component({
  selector: "app-tier-managment",
  templateUrl: "./tier-managment.component.html",
  standalone: false,
})
export class TierManagmentComponent {
  @Input() contractId!: number;
  @Input() packageId!: number;

  yearlyPrice: boolean = false;

  isEditingAll: boolean = false;
  selectedCycle = "monthly";
  contractPackage!: Package;
  editingPackage!: Package;
  selectedTier!: number;
  userRole = UserRoles;

  public options$!: Observable<Package[]>;

  tiers: Package[] = [];

  isLoading: boolean = false;
  loading = false;
  defaultPackages: Package[] = [];

  constructor(
    private tierManagmentService: TierManagmentService,
    private packageService: PackageService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.options$ = this.packageService.getDefaultPackage();
    if (this.packageId) {
      const subscription = this.packageService
        .getPackage(this.packageId)
        .subscribe((res) => {
          subscription.unsubscribe();
          this.loading = false;
          this.contractPackage = res;
          this.tiers = [res];
          const [firstTier] = this.tiers;
          this.editingPackage = firstTier;

          this.editingPackage = res;
          this.selectedTier = res.referencePackageId;
        });
    }
    else {
      this.options$.pipe(take(1)).subscribe((options) => {
        this.loading = false;
        this.defaultPackages = options;
        this.tiers = [...options];
      });
    }
  }

  onCategoryChange(pickedPackage: Package) {
    const currentPackage
      = this.contractPackage.referencePackageId === pickedPackage.id
        ? this.contractPackage
        : pickedPackage;
    currentPackage.referencePackageId = pickedPackage.id;
    this.tiers = [currentPackage];
    const [firstTier] = this.tiers;
    this.editingPackage = firstTier;
  }

  cancelEditingAll() {
    this.isEditingAll = false;
    this.loadData();
  }

  startEditingAll() {
    this.isEditingAll = true;
  }

  saveAllPlans() {
    if (this.packageId) {
      try {
        this.isLoading = true;

        const updateSubscription = this.packageService
          .updatePackage(this.editingPackage, this.packageId)
          .subscribe({
            next: () => {
              updateSubscription.unsubscribe();
              this.translate.instant("tier_succesfuly");
              this.loadData();
              this.isLoading = false;
              this.isEditingAll = false;
              showMessage(
                PopupType.Success,
                this.translate.instant("tier_succesfuly"),
              );
            },
            error: () => {
              this.isLoading = false;
            },
          });
      }
      catch {
        showMessage(PopupType.Danger, this.translate.instant("tier_failed"));
      }
    }
    else {
      try {
        this.isLoading = true;
        const updateSubscription = this.tierManagmentService.updateTiers(this.tiers).subscribe({
          next: () => {
            updateSubscription.unsubscribe();
            showMessage(
              PopupType.Success,
              this.translate.instant("tier_succesfuly"),
            );
            this.isLoading = false;
            this.isEditingAll = false;
          },
          error: () => {
            updateSubscription.unsubscribe();
            this.isLoading = false;
          },
        });
      }
      catch {
        showMessage(PopupType.Danger, this.translate.instant("tier_failed"));
      }
    }
  }

  setCycle(cycle: string) {
    this.selectedCycle = cycle;
  }
}
